<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Welcome!</h4>
      </div>
      <div class="card-content row">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-12">
              <p>Welcome to Qualification Check's new look website! You'll find the same great features you've always enjoyed from Quaification Check, just faster and sleeker!</p>
              <p>If you have any feedback, please don't hesitate to contact us with the chat box in the bottom right corner!</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="submit()" class="btn btn-fill btn-wd pull-right">Great, let's go!</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'modal-message-ack',
    data () {
      return {
        loading: false
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true;
            this.$api.getAccount()
              .then(response => {
                response.data.interuptMessageAck = 1
                response.data.company = null
                response.data.institute = null
                this.$api.updateAccount(response.data)
                  .then(response => {
                    this.$api.refreshLogin()
                      .then(response => {
                        this.$snotify.success("", "Enjoy")
                        this.$modal.close()
                      })
                      .catch(error => {
                        console.log(error)
                        this.loading = false;
                      })
                  })
                  .catch(error => {
                    console.log(error)
                    this.loading = false;
                  })
              })
              .catch(error => {
                console.log(error)
                this.loading = false;
              })
          }
        })
      }
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>